import PublisherFormPage from "./PublisherFormPage"

const PublisherCreate = () => {
  return (
    <PublisherFormPage></PublisherFormPage>
  )
}

export default PublisherCreate;